import { render } from "./AppAddressBlockie.vue?vue&type=template&id=95db8252&scoped=true&ts=true&lang=html"
import script from "./AppAddressBlockie.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAddressBlockie.vue?vue&type=script&setup=true&lang=ts"

import "./AppAddressBlockie.vue?vue&type=style&index=0&id=95db8252&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/EthVM/EthVM/v2/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95db8252"]])

export default __exports__